import React from 'react';
import ReactDOMServer from 'react-dom/server';
export default class TileAddToCart extends React.Component {
  constructor(props){
    super(props);

    this.state = {product_id: this.props.product_id, quantity: 1 , calling: false};

    this.handleSubmit = this.handleSubmit.bind(this);
    this.valid = this.valid.bind(this);

  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
      var t = this;
      t.setState({calling:true});
      $.post(Routes.add_cart_item_path({ id: t.state.product_id, format: "json" }) , { add_cart_form: this.state }, function (data) {
        t.setState({calling:false});


        update_cart_item_quantity(data.cart.item_count);
        t.setState({show_success_modal: true});
        $('#' + t.state.product_id + "_success").modal({keyboard:false}).on("hidden.bs.modal", function (e){
          t.setState({show_success_modal:false});

        });
      }
        , 'JSON').
      fail(function(data, status, error){
        document.cookie = "rmrc_error_modal=" + data.responseJSON['errors'] + ";max-age=30";
        window.location.href = window.location;
      });
  }

  valid(){
    return this.state.quantity > 0 && !this.state.calling;
  }

  getFaq(faq){
    if (this.props[faq] && this.props[faq].length !== 0){
    let html = {__html: this.props[faq]}
     return (
        <div dangerouslySetInnerHTML={html}>

        </div>
      )
    
    }
  }


  cart_button_message(){
    if(this.state.calling){
      return (
        <img src={this.props.spinny} height="20px;" />
      );
    }

    else{
      return "Add To Cart";
    }
  }


  success_modal(){
    if(this.state.show_success_modal){

      let modal_body = (<div className="modal-dialog v-centered" role="document">
        <div className="modal-content">
        <div className="modal-header">
        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 className="modal-title" id="myModalLabel">Added To Cart</h4>
        </div>
        <div className="modal-body">
          Product was successfully added to cart!

          {this.getFaq('video_transmitter_faq')}
          {this.getFaq('battery_faq')}
          {this.getFaq('glue_faq')}
        </div>
        <div className="modal-footer">
        <button type="button" className="btn btn-blue pull-left" data-dismiss="modal" >Keep Shopping</button>
        <a href={Routes.shopping_cart_path()} className="btn btn-primary"><i className="glyphicon glyphicon-shopping-cart"></i> Cart</a>
        </div>
        </div>
        </div>);

      if (!this.props.is_carousel_item){

      return (
        <div className="modal" style={{width:400 + "px;"}} id={this.state.product_id + "_success"} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
            {modal_body}
        </div>
      );
     }
     else {
     
        $('#cart-add-modal').html(ReactDOMServer.renderToStaticMarkup(modal_body)); 
        $('#cart-add-modal').modal('show'); 
     }
    }
  }

  render(){
    var t = this;
    if (t.props.can_order && !t.props.is_pre_release){
    return (
      <form className="" data-turbolinks="false" onSubmit={this.handleSubmit}>
      <button type="submit" className="btn btn-primary btn-sm pull-right" disabled={!this.valid()}>
      {t.cart_button_message()}
      </button>
      {t.success_modal()}
      </form>
    );
  }
    else {
      return (
        <a href={"/products/details/" + t.props.slug} className="btn btn-primary btn-sm pull-right">More Info</a>

        )
    }
  }

}




// WEBPACK FOOTER //
// ./app/javascript/store_front/app/components/tile_add_to_cart.jsx